import MapleLeafBg from '~/assets/holiday/thanksgiving/menu/mapleLeafBg.png';
import TopLeftWidget from '~/assets/holiday/thanksgiving/menu/topLeftWidget.png';
import { BaseMenu } from './BaseMenu';

export const ThanksgivingMenu = () => (
  <BaseMenu
    config={{
      containerBgClass: 'bg-[#6F0F1B] bg-contain bg-bottom bg-no-repeat',
      containerStyle: { 'background-image': `url(${MapleLeafBg})` },
      collapseButtonZIndex: true,
      activeColor: '#BC4150',
      tooltipBgColor: '#BC4150',
      linkTooltipBgColor: '#BC4150',
      decoration: <img class="absolute -left-2.5 -top-1.5 w-[79px]" src={TopLeftWidget} alt="top left widget" />,
    }}
  />
);
